import { React, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import Carousel from "react-material-ui-carousel";
import {
  Typography,
  Stack,
  Button,
  Divider,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import image1 from "../../images/IMG_3569.png";
import image2 from "../../images/IMG_3553.png";
import image3 from "../../images/IMG_3563.png";
import image4 from "../../images/IMG_3573.png";
import sabiaLogo from "../../images/icon-sabia.svg";
import iconRevela from "../../images/logoRevela2.svg";
import iconRevela2 from "../../images/logoRevela3.svg";
import infoLogo from "../../images/warning-2.svg";

import * as service from "../../services/clientSabia";
import api from "../../services/api";
import { localStorageRemoveItem, setItemEncryp } from "../../utils/cryptoData";

const styles = {
  carousel: {
    height: "200px",
    width: "100%",
    "& img": {
      height: "200px",
      width: "-webkit-fill-available",
    },
  },
  img: {
    width: "400px",
    height: "25px",
    width: "25px",
    marginRight: "32px",
  },
  sobre: {
    color: "#1E729F",
    textAlign: "center",
    display: "grid",
    alignContent: "center",
    gridTemplateColumns: "0.5fr 3fr",
    marginRight: "15px",
  },
  // revela: {
  //   color: "#1E729F",
  //   width: "300px",
  //   textAlign: "center",
  //   zIndex: "1",
  // },
  // revela2: {
  //   width: "200px",
  //   textAlign: "center",
  //   zIndex: "1",
  //   margin: "auto",
  // },
};
const items = [
  {
    src: image1,
  },
  {
    src: image2,
  },
  {
    src: image3,
  },
  {
    src: image4,
  },
];

const Login = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  async function handleApiLogin(token, clicked = false) {
    setLoading(true);
    try {
      const response = await api.post("/login", { token: token });
      if (response.data.status && clicked === true) {
        const loginUrl =
          service.authorizationURL +
          `?response_type=` +
          service.responseType +
          `&grant_type=` +
          service.grantType +
          `&client_id=` +
          service.clientID +
          `&redirect_uri=` +
          service.redirectURI;

        window.location.replace(loginUrl);
      } else {
        if (response.data?.usuario?.no_cpf) {
          clearLocalStorage();
          localStorage.setItem("sabiaToken", token);
          setItemEncryp("usuario", response.data.usuario);

          localStorage.setItem("jwt", JSON.stringify(response.data.jwt));
          api.defaults.headers.authorization = `Bearer ${response.data.jwt}`;
          if (response.data.usuario.dt_atualizado_em !== null) {
            window.location.replace("/vinculos");
          } else {
            window.location.replace("/cadastro");
          }
        }
      }
    } catch (error) {
      setError("Ocorreu um erro ao realizar login, por favor tente novamente.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    let token = service.extractToken();
    let scope = service.extractScope();
    let duration = service.extractDuration();

    service.Token(token, duration, scope);

    if (token !== null) {
      handleApiLogin(token);
    }
  }, [location.pathname]);

  const clearLocalStorage = () => {
    localStorage.removeItem("sabiaTokenExpirationTime");
    localStorage.removeItem("sabiaScope");
    localStorage.removeItem("sabiaToken");
    localStorage.removeItem("usuario");
    localStorage.removeItem("vinculo_ativo");
    localStorage.removeItem("jwt");
    localStorage.removeItem("paciente");
    // removendo com criptografia
    localStorageRemoveItem("usuario");
    localStorageRemoveItem("vinculo_ativo");
    localStorageRemoveItem("paciente");
    api.defaults.headers.authorization = null;
  };

  async function handleLogin() {
    if (String(localStorage.getItem("sabiaToken")) === "null") {
      const loginUrl =
        service.authorizationURL +
        `?response_type=` +
        service.responseType +
        `&grant_type=` +
        service.grantType +
        `&client_id=` +
        service.clientID +
        `&redirect_uri=` +
        service.redirectURI;
      window.location.replace(loginUrl);
    } else {
      const token = String(localStorage.getItem("sabiaToken"));
      if (token) {
        handleApiLogin(token, true);
      } else {
        const loginUrl =
          service.authorizationURL +
          `?response_type=` +
          service.responseType +
          `&grant_type=` +
          service.grantType +
          `&client_id=` +
          service.clientID +
          `&redirect_uri=` +
          service.redirectURI;
        window.location.replace(loginUrl);
      }
    }
  }

  function handleRegister() {
    /* const registrationUrl = service.authHost +
      "/register/" +
      "?redirect_uri=" + service.redirectURI; */

    const registrationUrl =
      service.registrationURL +
      "?client_id=" +
      service.clientID +
      "&redirect_uri=" +
      service.redirectURI +
      `&response_type=code`;

    window.location.replace(registrationUrl);
  }

  const LogoContainer = () => {
    return (
      <Stack
        sx={{ zIndex: "2" }}
        position={{ sx: "static", md: "absolute" }}
        top={{ xs: "40px", md: "30%" }}
        left={{ xs: "0%", md: "calc((63vw / 2) - 150px)" }}
        width={{ xs: "100vw", md: "300px" }}
        alignItems={"center"}
      >
        <Stack width={{ xs: "250px", sm: "300px", md: "400px", xl: "540px" }}>
          <Stack width={{ xs: "250px", sm: "300px", md: "400px", xl: "540px" }}>
            <img
              src={iconRevela}
              alt="Icone Prontuário eletrônico Para ELA"
              width="100%"
            />
          </Stack>

          <Divider
            sx={{
              background: "yellow",
              height: "1px",
              mt: 3,
              width: "80%",
              margin: "2rem auto",
            }}
          ></Divider>
          <Stack
            width={{ xs: "150px", sm: "150px", md: "200px", xl: "277px" }}
            margin="0 auto"
            marginTop={{ xs: "-1rem", md: "0px" }}
          >
            <img src={iconRevela2} alt="Icone Projeto Revela" width="100%" />
          </Stack>
        </Stack>
      </Stack>
    );
  };

  return (
    <>
      <div
        style={{
          width: "100vw",
          height: "100vh",
          overflow: "hidden",
        }}
      >
        <Stack display={{ xs: "none", md: "block" }}>
          <LogoContainer />
        </Stack>

        <Stack direction={"row"}>
          <Stack width={{ xs: "100vw", md: "63vw" }}>
            <Carousel
              sx={{ padding: 0 }}
              indicatorContainerProps={{
                style: {
                  zIndex: 1,
                  marginTop: "-50px",
                  position: "absolute",
                },
              }}
            >
              {items.map((item, i) => (
                <img
                  key={i}
                  style={{ flex: 1, width: "100%", height: "100vh" }}
                  src={item.src}
                  alt="Happy"
                />
              ))}
            </Carousel>
          </Stack>
          <Stack
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backdropFilter: "blur(10px)",
              transition: "margin 0.1s ease",
              boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.15)",
            }}
            width={{ xs: "90vw", sm: "80vw", md: "37vw" }}
            height={{ xs: "80vh", sm: "80vh", md: "100vh" }}
            position={{ xs: "absolute", md: "relative" }}
            zIndex={{ xs: "1", md: "0" }}
            bgcolor={{ xs: "rgba(255, 255, 255, 0.5)" }}
            margin={{ xs: "5vh 5vw", sm: "5vh 10vw", md: "0 0" }}
            borderRadius={{ xs: "20px", md: "0 0" }}
          >
            <Stack display={{ xs: "block", md: "none" }}>
              <LogoContainer />
            </Stack>

            <Stack spacing={4} direction="column">
              <Typography
                variant="h4"
                gutterBottom
                component="div"
                fontWeight="600"
                color="#1E729F"
                textAlign="center"
              >
                Login do usuário
              </Typography>
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#1E729F",
                  textTransform: "none",
                  fontWeight: 600,
                }}
                onClick={handleLogin}
                startIcon={
                  loading ? (
                    <CircularProgress size="20px" sx={{ color: "#fff" }} />
                  ) : (
                    <img src={sabiaLogo} style={styles.img} alt="Logo sabiá" />
                  )
                }
              >
                Entrar com o Sabiá
              </Button>
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#3E94C2",
                  textTransform: "none",
                  fontWeight: 600,
                }}
                onClick={handleRegister}
                startIcon={
                  <img src={sabiaLogo} style={styles.img} alt="Logo sabiá" />
                }
              >
                Criar conta no Sabiá
              </Button>
              <Typography gutterBottom component="div" style={styles.sobre}>
                <img alt="Icone do sabiá" src={infoLogo} style={styles.img} />
                <a
                  href="https://login.sabia.ufrn.br/saiba_mais/"
                  target="_blank"
                  style={{ textDecoration: "None", color: "#1E729F" }}
                  rel="noreferrer"
                >
                  Saiba mais sobre o Sabiá
                </a>
              </Typography>
            </Stack>
          </Stack>
          {!!error && (
            <Snackbar
              open
              onClose={() => {}}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
              <Alert
                severity="error"
                children={error}
                onClose={() => setError(null)}
              />
            </Snackbar>
          )}
        </Stack>
      </div>
    </>
  );
};

export default Login;
